export default __webpack_public_path__ + "static/media/user-hiten.65531486.jpg";